<template>
    <div class="o-filter-options o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap u-margin-bottom-40">
        <div class="flex-grid__item--third">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Claim Status
            </div>
            <claim-status></claim-status>
        </div>
        <div class="flex-grid__item--third">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Claim Type
            </div>
            <claim-type></claim-type>
        </div>
        <div class="flex-grid__item--third" v-if="claimType !== 'personal_injury'">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Disease or Accident
            </div>
            <disease-or-accident></disease-or-accident>
        </div>
        <div class="flex-grid__item--third" v-if="diseaseOrAccident === 'disease'">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Disease Type
            </div>
            <disease-type></disease-type>
        </div>
        <div class="flex-grid__item--third" v-if="diseaseOrAccident === 'accident' || claimType === 'personal_injury'">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Accident Type
            </div>
            <accident-type></accident-type>
        </div>
        <div class="flex-grid__item--third">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Set Date Range
            </div>
            <dates></dates>
        </div>
<!--         <div class="flex-grid__item--third">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Reserves
            </div>
            <claim-costs></claim-costs>
        </div> -->
        <div class="flex-grid__item--third">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Reserve Value
            </div>
            <reserve-value></reserve-value>
        </div>
        <div class="flex-grid__item--third" v-if="reserveValue === 'own'">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Reserve Range
            </div>
            <reserve-range></reserve-range>
        </div>
    </div>
</template>

<script>
    import Control from 'components/form/Control';
    import ClaimStatus from './form/ClaimStatus';
    import ClaimType from './form/ClaimType';
    import ClaimCosts from './form/ClaimCosts';
    import DiseaseOrAccident from './form/DiseaseOrAccident';
    import DiseaseType from './form/DiseaseType';
    import AccidentType from './form/AccidentType';
    import ReserveValue from './form/ReserveValue';
    import ReserveRange from './form/ReserveRange';
    import Dates from './form/Dates';

    export default {
        name: 'page-form',
        components: {
            Control,
            ClaimStatus,
            ClaimCosts,
            ClaimType,
            DiseaseOrAccident,
            DiseaseType,
            AccidentType,
            ReserveValue,
            ReserveRange,
            Dates,
        },
        computed: {
            claimType: {
                get() {
                    return this.$store.getters['dashboards/claimType'];
                },
            },
            diseaseOrAccident: {
                get() {
                    return this.$store.getters['dashboards/diseaseOrAccident'];
                },
            },
            reserveValue: {
                get() {
                    return this.$store.getters['dashboards/reserveValue'];
                },
            }
        }
    }
</script>



// WEBPACK FOOTER //
// PageForm.vue?09b7b4e8